import { render, staticRenderFns } from "./editUserInfo.vue?vue&type=template&id=5f12e8f1&scoped=true"
import script from "./editUserInfo.vue?vue&type=script&lang=js"
export * from "./editUserInfo.vue?vue&type=script&lang=js"
import style0 from "./editUserInfo.vue?vue&type=style&index=0&id=5f12e8f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12e8f1",
  null
  
)

/* custom blocks */
import block0 from "./editUserInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports